import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import AccountCard from 'pages/account/account-details/account-card'
import AccountLinkRow from 'components/account-link-row'
import useAccountDetailsStyles from 'pages/account/account-details/styles'
import { useRequirementCardStyles } from './styles'

const RequirementCard = ({
  title,
  statusChip,
  actions = [],
  testid,
  children,
}) => {
  const classes = useAccountDetailsStyles()
  const requirementClasses = useRequirementCardStyles()
  const visibleActions = actions.filter(Boolean)

  return (
    <div data-testid={testid}>
      <AccountCard title={title} action={statusChip} classes={classes}>
        {children ? (
          <Typography className={classes.fieldCaption}>{children}</Typography>
        ) : null}
        {visibleActions.length > 0 ? (
          <Box className={requirementClasses.actions}>
            {visibleActions.map((action, index) => (
              <AccountLinkRow key={action.title || index} {...action} />
            ))}
          </Box>
        ) : null}
      </AccountCard>
    </div>
  )
}

RequirementCard.propTypes = {
  title: PropTypes.string.isRequired,
  statusChip: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.object),
  testid: PropTypes.string,
  children: PropTypes.node,
}

export default RequirementCard
